'use strict';

import 'isomorphic-fetch';
import { Network } from 'relay-runtime';
import SV from 'server-vars';
import { getBuyerToken } from 'dibs-cookie-jar';
import { createFetcher } from 'dibs-relay-network-layer/client';

export default Network.create(
    createFetcher({
        getQueries: () => ({
            ...getBuyerToken(document.cookie),
            locale: SV.get('locale'),
        }),
    })
);



// WEBPACK FOOTER //
// ./assets/js/global/relayModernNetwork.es.js